<template>
  <div class="home-view">
    <div class="welcome-content">
      <div class="icon-wrapper">
        <i class="pi pi-qrcode"></i>
      </div>
      <h1>RapID Audit</h1>
      <p class="welcome-text">Welcome to RapID Audit System</p>
      <div class="actions">
        <router-link v-if="isAuthenticated" to="/audit/start" class="start-button">
          <i class="pi pi-play"></i>
          <span>Start Audit</span>
        </router-link>
        <router-link v-else to="/login" class="login-button">
          <i class="pi pi-sign-in"></i>
          <span>Login to Start</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useAuthStore } from '../stores/auth.store';

const authStore = useAuthStore();
const { isAuthenticated } = storeToRefs(authStore);
</script>

<style scoped>
.home-view {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  padding: 2rem;
}

.welcome-content {
  text-align: center;
  max-width: 500px;
  width: 100%;
}

.icon-wrapper {
  width: 80px;
  height: 80px;
  margin: 0 auto 2rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 2.5rem;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);
}

h1 {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 0.5rem;
  font-size: 2.5rem;
  font-weight: 700;
}

.welcome-text {
  color: #666;
  font-size: 1.2rem;
  margin-bottom: 2.5rem;
}

.actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.start-button,
.login-button {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 2rem;
  font-size: 1.125rem;
  font-weight: 600;
  border-radius: 12px;
  text-decoration: none;
  transition: all 0.2s ease;
  border: none;
  cursor: pointer;
}

.start-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.start-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5);
}

.login-button {
  background: white;
  color: #667eea;
  border: 2px solid #667eea;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.login-button:hover {
  background: #667eea;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.start-button i,
.login-button i {
  font-size: 1.25rem;
}

@media (max-width: 768px) {
  .home-view {
    padding: 1rem;
  }

  .icon-wrapper {
    width: 64px;
    height: 64px;
    font-size: 2rem;
    margin-bottom: 1.5rem;
  }

  h1 {
    font-size: 2rem;
  }

  .welcome-text {
    font-size: 1rem;
    margin-bottom: 2rem;
  }

  .start-button,
  .login-button {
    padding: 0.875rem 1.5rem;
    font-size: 1rem;
  }
}
</style>
